export default __webpack_public_path__ + "static/media/RevofilFine.a8981adc.png";